import { Injectable, inject } from '@angular/core';
import { BdPermissionsCompanyStore } from '../store/company/company.store';
import { HttpClient } from '@angular/common/http';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { Observable } from 'rxjs';
import {
  BdCompany,
  BdCompanyGroup,
} from '@bindoc-projects/resource-domain-lib';
import type { BdGraphApiUser } from '../users/user.model';
import { ApiEndpointKey } from '@bindoc-projects/app-config-domain-lib';

@Injectable({
  providedIn: 'root',
})
export class BdPermissionsCompanyService {
  private _httpClient = inject(HttpClient);
  private _environmentService = inject(BdAppEnvironmentService);

  private _store: BdPermissionsCompanyStore;

  constructor() {
    this._store = new BdPermissionsCompanyStore(
      this._environmentService.load(ApiEndpointKey.BD_PERMISSION_RESOURCE_URL),
    );
  }

  public getAll(): Observable<BdCompany[]> {
    const url = this._store.getAll();

    return this._httpClient.get<BdCompany[]>(url);
  }

  public getById(companyId: string): Observable<BdCompany> {
    const url = this._store.getById(companyId);

    return this._httpClient.get<BdCompany>(url);
  }

  public getGroupsByCompanyId(companyId: string): Observable<BdCompanyGroup[]> {
    const url = this._store.getGroupsByCompanyId(companyId);

    return this._httpClient.get<BdCompanyGroup[]>(url);
  }

  public getUsersByCompanyId(companyId: string): Observable<BdGraphApiUser[]> {
    const url = this._store.getUsersByCompanyId(companyId);

    return this._httpClient.get<BdGraphApiUser[]>(url);
  }
}
